import { render, staticRenderFns } from "./adsTabs.vue?vue&type=template&id=5970ac7c&scoped=true"
import script from "./adsTabs.vue?vue&type=script&lang=js"
export * from "./adsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5970ac7c",
  null
  
)

export default component.exports